import { useGetLeadershipPVQuery } from "../../../../../../../../../services/PerformanceHistory/performanceHistoryAPI";
import { PerfHistoryDataProps } from "../ABOProfilePerfHistoryKPIs";

const ABOProfilePerfHistoryLeadershipPV = ({
  affAbo,
  locale,
  isoCountryCode,
  period,
  periodCount = 12,
  children,
}: PerfHistoryDataProps) => {
  const { isFetching, data, isError } = useGetLeadershipPVQuery({
    affAbo,
    period,
    periodCount,
    locale,
    market: isoCountryCode,
  });

  return <>{children({ data, isFetching, isError })}</>;
};

export default ABOProfilePerfHistoryLeadershipPV;
